import { render, staticRenderFns } from "./officialReg.vue?vue&type=template&id=2c6040e6"
import script from "./officialReg.vue?vue&type=script&lang=js"
export * from "./officialReg.vue?vue&type=script&lang=js"
import style0 from "./officialReg.vue?vue&type=style&index=0&id=2c6040e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports